export const defaultMapOptions = {
    enableCompass: false,
    enableZoomControl: false,
    enableLocationBar: false,
    enableDistanceLegend: false,
    enablePrintView: false,
    enableCompassOuterRing: false,
    enableMyLocation: false
}

export const defaultMiniMapOptions = {
    attributionControl:false,
    zoom:16,
    dragging:false,
    zoomControl:false,
    boxZoom:false,
    doubleClickZoom:false,
}

export const tileLayers = [
    {
        layer : '일반',
        wms: 'Base',
        img : require('..//img/base.png')
    },
    {
        layer : '항공',
        wms: 'Sat',                
        img : require('..//img/sat.png')
    }

]


